// axios
import axios from 'axios'
import Vue from 'vue'
import auth from '@/store/auth'
import toast from '@/store/toast'
import store from '@/store/index'
import { i18n } from '@/plugins/i18n'
// eslint-disable-next-line import/no-absolute-path,import/no-unresolved

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // timeout: 1000,
  headers: {
    Accept: 'application/json',
    iid: 1,
    version: '1.0.3',
  },
})

axiosIns.interceptors.request.use(
  config => {
    // Do something before request is sent

    const accessToken = auth.state.token

    // eslint-disable-next-line no-param-reassign
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`
    config.headers['Accept-Language'] = i18n.locale

    // console.log(i18n.locale)

    return config
  },
  error => {
    Promise.reject(error)
  },
);

axiosIns.interceptors.response.use(
  response => {
    if (response.data.entering_level_0 != null && response.data.entering_level_1 != null) {
      store.commit('SET_ENTERING_LEVEL', { level0: response.data.entering_level_0, level1: response.data.entering_level_1 })
    }

    return response;
  },
  error => {
    if (error.response && error.response.status === 401) {
      auth.dispatch('logout')
    }
    toast.dispatch('error', error.response ? error.response.data.message : error.message)
    Promise.reject(error)
    throw error;
  },
);

Vue.prototype.$http = axiosIns

export default axiosIns
